module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA3klEQVQokZ2SsW0DMQxFVWSIK24Aj5HChcuMoEL/6aAprk+AZIcL4EHiPVS4yBhKQ9k6wUKQECBI6POLlPid6wzY1nV9AjKQLd/6uptJOgIFeLGYzW9nko59l0MIYQa+Le6IHXZoicV8q0BKaUopTfViwwpQKum9Ia5N3o66w2KMr223sizL84jYYcU1BdnekIEs6SLp8ggD8pAIfJkPif8bVdLHXz8HeNutQ9JnXUcIYQ4hzHUdht3XUQHv/STpOhKApKv3ftoJwDnnYoyn3yQXYzwNNQucH4j83Nf9AIUyMSx3J79QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/images/icon_gw.png
// module id = no0D
// module chunks = 2